import { format } from 'date-fns-tz';

const SHOPEE_ECOMMERCE_ID = 3;
const TIKTOK_ECOMMERCE_ID = 1;

const getPostTargetRequest = (form) => {
  return {
    brandId: form?.brandId?.id,
    appliedAt: format(form?.appliedAt, 'yyyy-MM'),
    targetGmv: form?.targetGmv,
    platformTargets: [
      {
        ecommerceId: SHOPEE_ECOMMERCE_ID,
        targetViews: parseInt(form?.targetViewsShopee),
        targetCtr: form?.targetCtrShopee,
        targetCtor: form?.targetCtorShopee,
        targetAov: form?.targetAovShopee,
      },
      {
        ecommerceId: TIKTOK_ECOMMERCE_ID,
        targetViews: parseInt(form?.targetViewsTiktok),
        targetCtr: form?.targetCtrTiktok,
        targetCtor: form?.targetCtorTiktok,
        targetAov: form?.targetAovTiktok,
        targetErr: form?.targetErrTiktok,
      },
    ],
  };
};

export default getPostTargetRequest;
